<template>
    <component :is="cardElement" :title="cardTitle" :class="cardClass" :icon="cardIcon" :header-color="cardColor"
        v-show="gc_assessment_items.length || bi_assessment_items.length">

        <!-- Behavioral indicators section -->

        <enac-atpl-dashboard-level-report-edit-assessment :id="id_behavioural_indicators" :id-assessment-guide="id_assessment_guide"
            :bus="bus" :item-types="flight_phases_names" v-model="state_bi_values" :authors="state_bi_authors" :editDisabled="editDisabled"
            :assessment-items="bi_assessment_items" assessment-type="behavioural-indicator"
            :title="lang.polaris.common.flight_phases" :title-top="1">
        </enac-atpl-dashboard-level-report-edit-assessment>

        <!-- General criteria section -->

        <enac-atpl-dashboard-level-report-edit-assessment :id="id_general_criterias" :id-assessment-guide="id_assessment_guide"
            :bus="bus" :item-types="competency_domains_names" v-model="state_gc_values" :authors="state_gc_authors" :editDisabled="editDisabled"
            :assessment-items="gc_assessment_items" assessment-type="general-criteria"
            :title="lang.polaris.training.competencies">
        </enac-atpl-dashboard-level-report-edit-assessment>

        <!-- Assessment guide modal -->

        <trax-ui-modal-default :id="id_assessment_guide" :bus="bus" :title="lang.polaris.common.assessment_guide">
            <enac-custom-atpl-assessment-edit-guide :id="id_assessment_guide" :bus="bus">
            </enac-custom-atpl-assessment-edit-guide>
        </trax-ui-modal-default>

    </component>
</template>

<script>
    export default {
    
        props: {
            id: {default: 'enac-atpl-dashboard-level-report-learner-edit'},
            source: {default: '2'},
            target: {default: '3'},
            editDisabled: null,
            cardElement: {default: 'trax-ui-card'},
            cardTitle: {default: lang.polaris.training.assessment},
            cardClass: {default: 'mt-3'},
            cardIcon: null,
            cardColor: null
        },

        data: function() {
            return {
                lang: lang,
                id_behavioural_indicators: this.id+'-bi',
                id_general_criterias: this.id+'-gc',
                id_assessment_guide: this.id+'-guide',
                bi_assessment_items: data.assessment_items['behavioural-indicator'],
                gc_assessment_items: data.assessment_items['general-criteria'],
                flight_phases_names: data.flight_phases_names,
                competency_domains_names: data.competency_domains_names,
                state_bi_values: {},
                state_bi_authors: {},
                state_gc_values: {},
                state_gc_authors: {},
                bus: this.$bus
            }
        },
        
        created: function() {
            this.bus.$on(this.id+'-states-data', this.setStates);
            this.bus.$on(this.id+'-states-updated', this.setStates);
            this.bus.$on(this.id+'-'+this.source+'-states-save', this.saveData);
        },

        methods: {

            setStates(states) {
                if (!states.assessments) {
                    this.state_bi_values = {};
                    this.state_bi_authors = {};
                    this.state_gc_values = {};
                    this.state_gc_authors = {};
                    return;
                }
                if (states.assessments.data.bi && states.assessments.data.bi.length != 0) {
                    this.state_bi_values = this.assessmentValues(states.assessments.data.bi);
                    this.state_bi_authors = this.assessmentAuthors(states.assessments.data.bi);
                }
                if (states.assessments.data.gc && states.assessments.data.gc.length != 0) {
                    this.state_gc_values = this.assessmentValues(states.assessments.data.gc);
                    this.state_gc_authors = this.assessmentAuthors(states.assessments.data.gc);
                }
            },

            saveData(data) {
                if (!data.assessments) data.assessments = {};
                data.assessments.bi = this.assessmentItems(this.state_bi_values, this.bi_assessment_items);
                data.assessments.gc = this.assessmentItems(this.state_gc_values, this.gc_assessment_items);
                this.bus.$emit(this.id+'-'+this.target+'-states-save', data);
            },

            assessmentValues(assessment) {
                var res = {};
                for (var index in assessment) res[index] = assessment[index].value;
                return res;
            },

            assessmentAuthors(assessment) {
                var res = {};
                for (var index in assessment) res[index] = assessment[index].author;
                return res;
            },

            assessmentItems(values, assessmentItems) {
                var res = {};
                for (var index in assessmentItems) {
                    var item = assessmentItems[index];
                    if (values[item.uuid]) res[item.uuid] = { value: values[item.uuid], type_code: item.item_type};
                }
                return res;
            }

        }

    }
</script>
